<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Référence du dossier : </span>
    <span>{{ detailsDossier.reference || "-" }}</span>
  </div>
  <div class="col-6">
    <span class="fw-bold">Date du dossier : </span>
    <span>{{ (detailsDossier.date | date: "dd/MM/yyyy") || "-" }}</span>
  </div>
</div>

<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Adresse : </span>
    <span>{{ detailsDossier.address || "-" }}</span>
  </div>
</div>

<div class="row mb-4">
  <div class="col-12">
    <div class="fw-bold">Lien avec l’immeuble à expertiser :</div>
    <div class="ms-2">{{ detailsDossier.connectionToTheProperty || "-" }}</div>
  </div>
</div>

<div class="row mb-4">
  <div class="col-12">
    <div class="fw-bold">Finalité de l'évaluation :</div>
    <div class="ms-2">{{ detailsDossier.purpose || "-" }}</div>
  </div>
</div>

<div class="row mb-4">
  <div class="col-12">
    <div class="fw-bold">Commentaires :</div>
    <div class="ms-2">{{ detailsDossier.comments || "-" }}</div>
  </div>
</div>
